<button mat-button color="{{colorName}}" class="mat-button {{colorName != '' ? 'mat-' + colorName : ''}} {{className}}"
  [matMenuTriggerFor]="menu">
  {{ this.localeText }}
  <mat-icon>arrow_drop_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="setLocale('fr-CA')"
    *ngIf="this.locale != 'fr-CA'">{{ 'Locale.French' | translate }}</button>
  <button mat-menu-item (click)="setLocale('en-CA')"
    *ngIf="this.locale != 'en-CA'">{{ 'Locale.English' | translate }}</button>
</mat-menu>
